import { Injectable } from "@angular/core";
import { ResultListVO } from "@app/shared/vo/resultList.vo";
import { MapperInterface } from "./mapper-inteface";
import { ResultListDTO } from "../dto/result-listDTO";
import { MapperPaginazione } from "./mapper-paginazione";
import { NotaLiquidazioneDTO } from "../dto/nota-liquidazioneDTO";
import { NotaLiquidazioneVO } from "../vo/nota-liquidazioneVO";
import { MapperNotaLiquidazione } from "./mapper-nota-liquidazione";

@Injectable({
  providedIn: "root",
})
export class MapperResultListNotaLiquidazione
  implements
    MapperInterface<
      ResultListDTO<NotaLiquidazioneDTO>,
      ResultListVO<NotaLiquidazioneVO>
    > {
  constructor(
    private mapperNotaLiquidazione: MapperNotaLiquidazione,
    private paginazioneMapper: MapperPaginazione
  ) {}

  convertVoToDto(
    vo: ResultListVO<NotaLiquidazioneVO>
  ): ResultListDTO<NotaLiquidazioneDTO> {
    const dto = new ResultListDTO<NotaLiquidazioneDTO>();
    if (vo != null) {
      dto.descrizione = vo.descrizione;
      dto.paginazione = this.paginazioneMapper.convertVoToDto(vo.paginazione);
      dto.stato = vo.stato;
      dto.resultList = this.mapperNotaLiquidazione.convertListVoToDto(
        vo.resultList
      );
    }
    return dto;
  }

  convertDtoToVo(
    dto: ResultListDTO<NotaLiquidazioneDTO>
  ): ResultListVO<NotaLiquidazioneVO> {
    const vo = new ResultListVO<NotaLiquidazioneVO>();
    if (dto != null) {
      vo.descrizione = dto.descrizione;
      vo.paginazione = this.paginazioneMapper.convertDtoToVo(dto.paginazione);
      vo.stato = dto.stato;
      vo.resultList = this.mapperNotaLiquidazione.convertListDtoToVo(
        dto.resultList
      );
    }
    return vo;
  }

  convertListVoToDto(
    voList: ResultListVO<NotaLiquidazioneVO>[]
  ): ResultListDTO<NotaLiquidazioneDTO>[] {
    return voList.map((vo) => this.convertVoToDto(vo));
  }

  convertListDtoToVo(
    dtoList: ResultListDTO<NotaLiquidazioneDTO>[]
  ): ResultListVO<NotaLiquidazioneVO>[] {
    return dtoList.map((dto) => this.convertDtoToVo(dto));
  }
}
